









































import Vue from 'vue'

export default Vue.extend({
  name: 'HistoricalAlarmPanel',
  components: {},
  data() {
    return {
      model: {},
    }
  },
  methods: {},
})
